var OldSeoContentBuilder = /** @class */ (function () {
    function OldSeoContentBuilder() {
        this.seoContent = {
            title: '',
            description: '',
            robots: '',
            fallback: false,
            metaTags: []
        };
    }
    OldSeoContentBuilder.prototype.withTitle = function (title) {
        this.seoContent.title = title;
        return this;
    };
    OldSeoContentBuilder.prototype.withIsFallback = function (isFallback) {
        this.seoContent.fallback = isFallback;
        return this;
    };
    OldSeoContentBuilder.prototype.withDescription = function (desc) {
        this.seoContent.description = desc;
        return this;
    };
    OldSeoContentBuilder.prototype.withRobots = function (robotsText) {
        this.seoContent.robots = robotsText;
        return this;
    };
    OldSeoContentBuilder.prototype.withMetaTags = function (metaTags) {
        this.seoContent.metaTags = metaTags;
        return this;
    };
    OldSeoContentBuilder.prototype.build = function () {
        return this.seoContent;
    };
    return OldSeoContentBuilder;
}());
export { OldSeoContentBuilder };
//# sourceMappingURL=old-seo-content-builder.js.map